import React from 'react';
import { Heading, Text, Box, Tabs } from 'lmc-ui-library';
import GuideItem from 'components/Guides/GuideItem';
import { GuidesProps } from './Guides.types';
import styles from './Guides.module.scss';

const Guides: React.FC<GuidesProps> = ({ tabsConfig, tabs }) => {
  return (
    <div className={styles.tabsContainer}>
      <Heading mode="heading" className={styles.heading}>
        Broker guides
      </Heading>
      <Text className={styles.subheading}>Helpful documents to get your started or learn more about us</Text>
      <Box>
        <Box.Content>
          <Tabs config={tabsConfig}>
            {tabs.map((tab) => (
              <>
                {tab.map((item) => {
                  const { url, heading, description } = item;

                  return <GuideItem url={url} heading={heading} description={description} />;
                })}
              </>
            ))}
          </Tabs>
        </Box.Content>
      </Box>
    </div>
  );
};

export default Guides;
